import { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { handleAccount, handleExhibition, handleCompete } from '@/(front-desk)/store'
import { usePathname, useRouter } from 'next/navigation'
import { ArrowTopRightOnSquareIcon, DocumentTextIcon, PencilIcon, TrophyIcon, UserIcon } from '@heroicons/react/24/outline'
import { loginPages } from '@/(front-desk)/layout'
import { reportError } from '@/(front-desk)/utils/functions'
import { ArrowRightIcon, ChevronDownIcon, XMarkIcon } from '@heroicons/react/20/solid'
import { throttle } from 'lodash'
import ExternalLinks from '@/(front-desk)/components/ExternalLinks'
import ActiveLink from '@/(front-desk)/components/ActiveLink'
import UserAvatar from '@/(front-desk)/components/UserAvatar'
import Link from 'next/link'
import logo from '@/(front-desk)/assets/images/2024/logo.png'
import axios from 'axios'
import lscache from 'lscache'
import classNames from 'classnames'



export default function UserNavbar() {

    const dispatch = useDispatch()
    const router = useRouter()
    const account = useSelector((state) => state.account)
    const pathname = usePathname()
    const [ dropMenu, setDropMenu ] = useState(false)
    const [ toggleMenu, setToggleMenu ] = useState(false)
    const [ btnDisabled, setBtnDisabled ] = useState(false)
    const [ isScroll, setIsScroll ] = useState(false)
    const dropMenuRef = useRef()
    const throttleScroll = throttle(handleScroll, 300)
    let lastScrollY = 0

    useEffect(() => {
        setDropMenu(false)
    }, [pathname])

    useEffect(() => {
        handleWindowResize()
        window.addEventListener('scroll', throttleScroll)

        return(() => {
            window.removeEventListener('scroll', throttleScroll, null)
        })
    }, [])


    useEffect(() => {
        handleWindowResize()
        window.addEventListener('resize', handleWindowResize, null)

        return() => {
            window.removeEventListener('resize', handleWindowResize, null)
        }
    }, [dropMenu])

    function handleWindowResize() {
        if (dropMenuRef.current) {
            if (dropMenu) {
                dropMenuRef.current.style.height = `${window.innerHeight}px`
            }
            else {
                dropMenuRef.current.style.height = `auto`
            }
        }
    }
    function handleScroll() {
        if (window.scrollY > 100) {
            if (lastScrollY > window.scrollY) {
                setIsScroll(false)
            }
            else {
                setIsScroll(true)
            }
        }
        else {
            setIsScroll(false)
        }
        lastScrollY = window.scrollY
    }

    function logout() {
        setBtnDisabled(true)

        axios.post('/api/v1/accounts/logout', {}, {
            headers: {
                Authorization: `Bearer ${lscache.get('access')}`
            }
        })
        .then((res) => {
            // console.log('res', res.data.body)
            router.push('/user/login')
            lscache.remove('access')
            lscache.remove('refresh')
            dispatch(handleAccount.actions.setData(null))
            dispatch(handleExhibition.actions.reset())
            dispatch(handleCompete.actions.reset())
            
            setBtnDisabled(false)
        })
        .catch((err) => {
            // console.log(err.config?.url, err)
            reportError(err)
            setBtnDisabled(false)
        })
    }

    const userNavbarClass = classNames('user-navbar', {
        'drop': dropMenu,
        '!hidden': loginPages.indexOf(pathname) !== -1,
        'scroll': isScroll
    })
    const toggleClass = classNames('btn', 'btn-toggle', 'drop-only', {
        'drop': toggleMenu
    })
    const btnHamburgerClass = classNames('btn-hamburger', 'lg:!hidden', {
        'active': dropMenu
    })
    const linkSectionClass = classNames('section', 'section-links', {
        'active': dropMenu
    })

    return (
        <>
        <div className={userNavbarClass}>
            <div className="navbar-content">
                <div className="section section-logo">
                    <Link className="logo" href="/" title="返回首頁">
                        <img src={logo.src} alt="臺灣產學策進會放視大賞 Logo" />
                    </Link>
                </div>
                <div className={linkSectionClass} ref={dropMenuRef}>
                    <div className="drop-only drop-only-top w-full mb-4">
                        { account.data &&
                            <div className="user flex gap-4 item-center">
                                <UserAvatar
                                    avatar={account.data.avatar}
                                    screenName={account.data.screen_name}
                                />
                                <div className="info">
                                    <div className="name">{account.data.screen_name}</div>
                                    <div className="code">{account.data.code}</div>
                                </div>
                            </div>
                        }
                        <button
                            className="btn btn-close p-4"
                            onClick={() => {setDropMenu(false)}}
                            aria-label="關閉選單"
                        ><XMarkIcon className="w-7 me-0" role="img" aria-label="X" /></button>
                    </div>
                    <ActiveLink href="/user/exhibit">
                        <DocumentTextIcon /> 參展
                    </ActiveLink>
                    <ActiveLink href="/user/compete">
                        <TrophyIcon /> 參賽
                    </ActiveLink>
                    { account.data?.is_judge &&
                        <ActiveLink href="/user/judge">
                            <PencilIcon /> 評審
                        </ActiveLink>
                    }
                    <ActiveLink className="drop-hide" href="/user/account">
                        <UserIcon /> 個人資料管理
                    </ActiveLink>

                    <button className={toggleClass} onClick={() => {setToggleMenu(!toggleMenu)}}>
                        <UserIcon /> 個人資料管理 <ChevronDownIcon className="arrow w-5 ms-1" />
                    </button>
                    <div className="drop-only toggle">
                        <ActiveLink href="/user/account/information" exact>
                            基本資料
                        </ActiveLink>
                        <ActiveLink href="/user/account/password-change" exact>
                            修改密碼
                        </ActiveLink>
                    </div>

                    {/* <Link href="/" className="drop-hide"> */}
                    <a href="/" target="_blank" className="drop-hide" title="另開新視窗前往首頁">
                        <ArrowTopRightOnSquareIcon /> 官網
                    </a>
                    <hr className="my-4 w-full border-black-600 drop-only" />
                    <div className="drop-only drop-only-bottom">
                        <button
                            className="btn w-fit"
                            onClick={logout}
                            disabled={btnDisabled}
                        >
                            登出
                            <ArrowRightIcon className="w-5 ms-1" />
                        </button>
                        <div className="external-links flex items-center">
                            <Link href="/" title="返回首頁">
                                <img className="logo" src={logo.src} alt="臺灣產學策進會放視大賞 Logo" />
                            </Link>
                            <ExternalLinks />
                        </div>
                    </div>
                </div>
                <div className="section section-user items-center">
                    <button
                        className="btn"
                        onClick={logout}
                        disabled={btnDisabled}
                    >登出</button>
                    { account.data &&
                        <Link className="p-3" href="/user/account/information">
                            <UserAvatar
                                avatar={account.data.avatar}
                                screenName={account.data.screen_name}
                            />
                        </Link>
                    }
                </div>
                <button
                    className={btnHamburgerClass}
                    onClick={() => {setDropMenu(!dropMenu)}}
                    aria-label="網頁選單按鈕"
                ><div></div></button>
            </div>
        </div>
        </>
    )
}
